<template>
    <div v-if="isLoading" class="loading-wrap">
        <Spinner class="loading"></Spinner>
    </div>
    <router-view/>
</template>
<script>
import { authCheckUrls } from './router/authCheckUrls';
export default{
    metaInfo: {
        title: 'tetete'
    },
    data() {
        return {
            isLoading: false,
            pendingRequests: 0,
            timeout: null,
        }
    },
    watch: {
        $route(to, from) {
            this.loginChk();
			// if(to.path != from.path) {
			// 	this.loginChk();
			// }
        },
    },
    methods: {
        handleTimeout() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            // access_token 만료 시간 체크
            const loginDt = this.$store.getters.getLoginDt
            const loginDate = new Date(loginDt)
            const now = new Date().getTime()
            const logoutLimit = new Date(loginDate.getTime() + 5 * 60 * 60 * 1000)
            const logoutLimitTime = logoutLimit.getTime() - now
            // 10분
            const time = 1000 * 60 * 10
            this.timeout = setTimeout(() => {
                this.$store.commit('setStatus', false);
                const path = this.$route.path
                const isBlocked = authCheckUrls.some(url => path.indexOf(url) > -1);
                if (isBlocked) {                
                    let url = '/kr/login';
                    location.href = url;
                }
            }, logoutLimitTime);
        },
        loginChk() {
			this.axios
				.get(this.api.member.info)
				.then((res) => {
					if(res.data){
						this.$store.commit('setStatus', true)
                        // this.$store.dispatch('setLoginStatus', true)
                        // this.handleTimeout()
                        if(!this.$store.state.myInfoStore.name) this.$store.state.myInfoStore = res.data
                        if((this.$store.state.myInfoStore.ptNo == '' || this.$store.state.myInfoStore.ptNo == null) && res.data.ptNo){
                            this.$store.state.myInfoStore.ptNo = res.data.ptNo
                        }
					}else{
                        this.$store.commit('setStatus', false)
						this.$store.commit('myInfoInit')
					}
				})
				.catch((err) => {
					console.log(err);
				});
        },
        setLoading(bool){
            this.isLoading = bool;
            if (!this.isLoading) {
                this.checkWidth();
            }
        },
        checkWidth() {
            setTimeout(() => {
                const tabMenuWrap = document.querySelector('.tab-menu-wrap');
                const tabMenu = document.querySelector('.tab-menu');
                const tabMenuItems = document.querySelectorAll('.tab-menu__item');

                if (tabMenuWrap && tabMenu && tabMenuItems.length > 0) {
                    const tabMenuWidth = tabMenu.offsetWidth;
                    const totalItemsWidth = Array.from(tabMenuItems).reduce((total, item) => total + item.offsetWidth, 0);

                    if (totalItemsWidth > tabMenuWidth + 1) {
                        tabMenuWrap.classList.add('on');
                    } else {
                        tabMenuWrap.classList.remove('on');
                    }
                }

                 // 테이블의 .table에 클릭 이벤트를 추가
                const tables = document.querySelectorAll('.table');
                tables.forEach((el) => {
                    this.checkTableWidth(el);
                    el.addEventListener("click", () => {
                        el.classList.add('active');
                    });
                });

                // tables.forEach((table) => {
                //     if (tables.offsetWidth > table.offsetWidth) {
                //         tables.classList.add('scroll');
                //     } else {
                //         tables.classList.remove('scroll');
                //     }
                //     table.addEventListener('click', () => {
                //         table.classList.add('active');
                //     });
                // }); 
            }, 0);
        },
        checkTableWidth(element) {
            let table = element.querySelector('table');
            if (table && table.offsetWidth > element.offsetWidth) {
                element.classList.add('scroll');
            } else {
                element.classList.remove('scroll');
            }
        },

        handleScroll() {
            var scrollPosition = window.scrollY;
            var windowWidth = window.innerWidth;  // 현재 창의 너비를 가져옵니다.

            // 화면 너비가 1240px 이상일 때만 조건을 변경합니다.
            const bottomElement = document.querySelector('.header');
            if (bottomElement) {
                if (windowWidth <= 1024) {
                    // 화면 너비가 1240px 이상일 때
                    if (scrollPosition >= 0) { // 항상 조건이 참이 됩니다.
                        bottomElement.classList.add('on');
                    } else {
                        bottomElement.classList.remove('on');
                    }
                } else {
                    // 화면 너비가 1240px 미만일 때
                    if (scrollPosition >= 48) {
                        bottomElement.classList.add('on');
                    } else {
                        bottomElement.classList.remove('on');
                    }
                }
            }
        }
    },
    mounted() {
        // 스크롤 이벤트 리스너 추가
        window.addEventListener('scroll', this.handleScroll);

        // this.loginChk();
        if(this.$store.getters.getHost == 'H0007'){
            document.querySelector('#app').classList = 'brain'
        }else if(this.$store.getters.getHost == 'H0008'){
            document.querySelector('#app').classList = 'mom'
        }else if(this.$store.getters.getHost == 'H0009'){
            document.querySelector('#app').classList = 'blood'
        }else{
            document.querySelector('#app').classList = ''
        }
        this.checkWidth();  // 페이지 로드 시 첫 번째 체크
    },
    updated() {
        this.checkWidth();  // DOM 업데이트 후 다시 체크
    },
    created() {
		this.pendingRequests = 0

		const apiArr = [
            '/api/info.do',
            '/api/user/checkDuplicate.do',
            '/api/user/checkDuplicateEmail.do'
        ]
		this.axios.interceptors.request.use(
            config => {
                if(!apiArr.includes(config.url)){
					this.pendingRequests++
                    this.setLoading(true);
                }
                return config;
            },
            error => {
                this.setLoading(false);
                return Promise.reject(error);
            }
        ),
        this.axios.interceptors.response.use(
            response => {
                if(!apiArr.includes(response.config.url)){
					this.pendingRequests--
					if(this.pendingRequests == 0) {
                        this.setLoading(false);
                    }
                }
                return response;
            },
            error => {
                this.setLoading(false);
                return Promise.reject(error);
            }
        )
	},
}
</script>
<style>
    @import url('@/assets/resource/css/reset.css');
    @import url('@/assets/resource/css/main.css');
    @import url('@/assets/resource/css/main_mo.css');
    @import url('@/assets/resource/css/common.css');
    @import url('@/assets/resource/css/font.css');
    @import url('@/assets/resource/css/sub.css');
    @import url('@/assets/resource/css/sub_mo.css');
    @import url('@/assets/resource/css/lang.css');
</style>